import { useReveal } from "../../hooks/useReveal";

const PORTRAIT = "https://customer-assets.emergentagent.com/job_indie-finance-1/artifacts/2kbwssjm_WhatsApp%20Image%202026-04-25%20at%2013.58.25.jpeg";

export const ChiSono = () => {
  const r1 = useReveal();
  const r2 = useReveal();

  return (
    <section
      id="chi-sono"
      data-testid="chi-sono-section"
      className="bg-ivory py-20 md:py-28"
    >
      <div className="container-editorial grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <div ref={r1} className="reveal lg:col-span-5">
          <div className="img-zoom border border-line">
            <img
              src={PORTRAIT}
              alt="Manuel Faustini CFA, consulente finanziario indipendente"
              className="w-full h-[520px] md:h-[640px] object-cover"
              data-testid="chi-sono-portrait"
            />
          </div>
          <div className="mt-6 flex items-center justify-between text-xs tracking-[0.22em] uppercase text-muteText">
            <span>Manuel Faustini · CFA</span>
            <span>Bergamo · Italia</span>
          </div>
        </div>

        <div ref={r2} className="reveal lg:col-span-7 lg:pt-12">
          <p className="overline mb-6">Chi sono</p>
          <h2 data-testid="chi-sono-title" className="display-2 mb-10">
            Una guida sobria<br />
            per decisioni che <em className="italic text-gold">contano</em>.
          </h2>

          <div className="space-y-6 text-muteText text-base md:text-lg leading-relaxed max-w-xl">
            <p>
              Da diversi anni accompagno imprenditori e professionisti ad alto reddito
              a dare ordine al proprio patrimonio. Ho studiato presso due tra le più
              grandi società di consulenza finanziaria indipendenti in Italia, e
              collaborato con una di esse, prima di mettermi in proprio. Ad oggi ho
              aiutato oltre 150 figure a pianificare e mettere ordine nel proprio
              patrimonio e nei propri investimenti.
            </p>
            <p className="font-serif italic text-2xl md:text-3xl text-navy leading-snug pt-4 border-l-2 border-gold pl-6">
              "La libertà patrimoniale nasce dalla chiarezza, non dalla complessità."
            </p>
          </div>

          <dl className="mt-14 grid grid-cols-2 gap-x-10 gap-y-8 max-w-lg">
            <div>
              <dt className="overline">Persone seguite</dt>
              <dd className="font-serif text-3xl md:text-4xl text-navy mt-2">150+</dd>
            </div>
            <div>
              <dt className="overline">Albo OCF</dt>
              <dd className="font-serif text-3xl md:text-4xl text-navy mt-2">Iscritto</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
};
